export default {
  createPlan: 'Create Plan',
  noModelsAvailable: 'No models available. Create the first one, or talk to the administrator.',
  search: 'Search',
  loading: 'Loading...',
  noPlansAvailable: 'No plans available for this model',
  running: 'Running...',
  headerName: 'Name',
  headerBudget: 'Budget ({unit})',
  upTo: 'up to {value}',
  headerPredicted: 'Predicted {kpiName} ({unit})',
  headerPeriod: 'Period',
  headerCreated: 'Created',
  defaultKpiName: 'Sales',
  defaultCurrency: 'USD',
  sharedWithExternalUsers: 'Shared with external users',
  betaOptimizerTooltip: 'This plan uses the new optimizer (beta)',
  createFromScratch: 'From Scratch',
  createLastYearActualBudget: 'Last Year, Actual Budget (Strategy Check)',
  createLastYearSaturationBudget: 'Last Year, Budget reaching Total Diminishing Returns Saturation',
  createNextYearBudgetPropagation: 'Next Year, Actual Budget Propagation (Forward Looking)',
  chooseFromScratchDescription: 'Set the period, budget and restrictions yourself and let the optimizer allocate the spend.',
  chooseActualBudgetTitle: 'Last Year\'s Actual Budget',
  chooseActualBudgetDescription: 'Optimizes the total spend of the last 12 months of data over that same period.',
  chooseSaturationTitle: 'Last Year at Saturation',
  chooseSaturationDescription: 'Optimizes the budget at which every channel reaches total diminishing returns over the last 12 months.',
  chooseNextYearTitle: 'Next Year Budget Propagation',
  chooseNextYearDescription: 'Optimizes the budget the model propagates for the upcoming year.',
  chooseTagStrategyCheck: 'Strategy Check',
  chooseTagSaturation: 'Saturation',
  chooseTagForwardLooking: 'Forward Looking',
  createFlexibleDates: 'Flexible Dates',
  chooseFlexibleTitle: 'Flexible Dates',
  chooseTagFlexible: 'Flexible',
  flexibleSummaryActual: 'Actual spend',
  flexibleSummaryPropagation: 'Budget propagation',
  flexibleSummaryEmpty: 'No data, adds 0',
  flexibleMonths: '{count} month | {count} months',
  flexibleWeeks: '{count} week | {count} weeks',
  flexibleHintActual: 'Actual spend is available through {date}.',
  flexibleHintPropagation: 'Budget propagation covers {from} to {to}.',
  chooseFlexibleDescription: 'Pick any period: its budget adds up the actual spend where the model has it and the budget propagation after that.',
  flexibleSummaryTotal: 'Budget',
  chooseNeedsMediaSpend: 'Requires media spend data in the model report',
  channelMismatchTitle: 'The model\'s channels have changed',
  channelMismatchIntro: 'This model\'s media channels no longer match the ones in this plan, likely because the model was updated after the plan was created. If you continue, the plan will use the model\'s current channels.',
  channelMismatchRemoved: 'Channels in the plan that no longer exist in the model (their spend will be discarded):',
  channelMismatchProceedAnyway: 'Continue anyway',
  channelMismatchCancel: 'Cancel'
}
